import { InfoStoreType } from '@/types/store/info-store.type';

export const state: InfoStoreType = {
  activities: null,
  languages: [],
  countries: [],
};
